import styled from "styled-components";
import { Select, Row } from "antd";

import * as Layout from "common/layout";

export const Content = styled(Layout.Content)`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const TeacherChineseNameHeading = styled.span`
  color: #fdd440;
  letter-spacing: 0.6px;
  font-size: 24px;
`;

export const TeacherNameHeading = styled.span`
  color: #ffffff;
  letter-spacing: 0.9px;
  font-size: 36px;
`;

export const TeacherNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media (max-width: 768px) {
    order: 1;
    text-align: center;
  }
`;

export const HeadingWrapper = styled(Layout.Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
  }
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 0px 0px 2px 2px;
  margin-bottom: 20px;
  height: 100%;
`;

export const CardTitle = styled.div`
  background-color: #d3e8ff;
  color: #1070b6;
  font-weight: bold;
  letter-spacing: 0.35px;
  padding: 10px 20px;
`;

export const CardContent = styled.div`
  padding: 10px 20px;
  color: #282828;
  text-align: left;
`;

export const FactList = styled.ul`
  padding-inline-start: 20px;

  list-style: none;

  li::before {
    content: "•";
    font-size: 20px;
    line-height: 10px;
    color: #1070b6;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
  }
`;

export const LevelSelect = styled(Select)`
  height: 36px;
  font-size: 14px;
  color: black;
  width: 100%;
  font-weight: normal;
  margin-bottom: 20px;
  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const FilterLevelsRow = styled(Row)`
  margin: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
